import React from 'react';
import { SortableList } from '../../../components/HOCs/withDragAndDrop';
import { Scrollbars } from 'react-custom-scrollbars';

import './SortableLists.css';
import { getTranslation } from '../../../assets/creator/translations';

const getDimensionsDependingOnPreviewType = (mobilePreview) => {
    if (mobilePreview) {
        //content block height for mobile preview
        //phone height (80 vmin)
        // screen height (100% - 130px)
        // height = (80vmin - 130px)
        // body height = (40vmin - 65px)
        // header footer height (20vmin - 33.5 px)
        // round header footer pixels down
        // add pixel to body
        // body height (40vmin - 66px)
        // header footer height (20vmin - 33px)
        return { header: 'calc(20vmin - 33px)', body: 'calc(40vmin - 66px)', footer: 'calc(20vmin - 33px)' };
    } else {
        //content block height for desktop preview
        //header - 60px
        //footer 6vh
        //that leaves us calc(94vh - 60px) height for elements
        //then: (trying to keep the proportions 1:2:1)
        // minheight header (and footer) has calc(23.5vh - 15px)
        // minheight body calc(47vh - 30px)
        return { header: 'calc(23.5vh - 15px)', body: 'calc(47vh - 30px)', footer: 'calc(23.5vh - 15px)', column: 'calc(70.5vh - 45px)' };
    }
};

const getSortableListComponent = (lists, props) => {
    if (lists.length > 1) {
        return lists.map((l) => (
            <SortableList
                key={l.listName}
                {...l /* spread all props */}
                handleDragChange={props.handleDragStart}
                onListChange={props.onListChange}
                handleOptionsOpen={props.handleOptionsOpen}
                isPreviewOn={props.isPreviewOn}
                elementType={props.type}
                getElement={props.getElement}
                showFixedElements={props.showFixedElements}
                bodyListName={props.bodyListName}
                isMobileOn={props.isMobileOn}
                changeConfig={props.changeConfig}
            />
        ));
    } else {
        return <SortableList
                    key={lists.listName}
                    {...lists /* spread all props */}
                    handleDragChange={props.handleDragStart}
                    onListChange={props.onListChange}
                    handleOptionsOpen={props.handleOptionsOpen}
                    isPreviewOn={props.isPreviewOn}
                    elementType={props.type}
                    getElement={props.getElement}
                    showFixedElements={props.showFixedElements}
                    bodyListName={props.bodyListName}
                    isMobileOn={props.isMobileOn}
                    changeConfig={props.changeConfig}
        />;
    }
}

const getGetLists = (props) => {
    const dimensions = getDimensionsDependingOnPreviewType(props.isMobileOn);
    // let newPropsBody = [ ...props.body ] 
    const lists = [
        { groupName: 'header', listName: 'header', placeholder: getTranslation('Grp_Header'), minHeight: dimensions.header, items: props.header },
    { groupName: 'body', listName: props.bodyListName, placeholder: getTranslation('Grp_Content'), minHeight: dimensions.body, items: props.body /*newPropsBody*/ },
        { groupName: 'footer', listName: 'footer', placeholder: getTranslation('Grp_Footer'), minHeight: dimensions.footer, items: props.footer }
    ];
    if (!props.isMobileOn && props.bodyListName === 'productListBody'){
        lists.push({ groupName: 'column', listName: 'column', placeholder: getTranslation('Grp_Column'), minHeight: dimensions.column, items: props.column });
    }
    return () => (
        <React.Fragment>
            {(() => {
                if (props.isMobileOn || props.bodyListName !== 'productListBody') {
                    return getSortableListComponent(lists, props);
                } else {
                    return (
                        <React.Fragment>
                            {getSortableListComponent(lists[0], props)}
                            <div className='sortable-lists__wrapper'>
                                <div className='sortable-lists__column sortable-lists__column--right'>
                                    {getSortableListComponent(lists.slice(1, -1), props)}
                                </div>
                            </div>
                        </React.Fragment>
                    );
                }
            })()}
        </React.Fragment>
    );
}



const MobileWithScrollbar = (getLists) => (
    <Scrollbars
        renderTrackVertical={({ style, ...props }) => <div className="scrollbar-track" {...props} style={{ ...style }} />}
        renderThumbVertical={({ style, ...props }) => <div className="scrollbar-thumb" {...props} style={{ ...style }} />}

        key="sortable-list__scrollbar"
    >
        <div className="mobile-sortable-lists-wrapper">
            {getLists()}
        </div>
    </Scrollbars>
)

//Sortable lists is naming convention from react-dnd
//each sortable list is a part of displayed page, be it a header, a footer or a body (content)
const SortableLists = (props) => {
    const getLists = getGetLists(props);

    if (props.isMobileOn) {
        return MobileWithScrollbar(getLists);
    } else {
        return getLists();
    }
};

export default SortableLists;